import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Edital } from '../models/edital-model';
import { ResultGetPaged, Combobox } from 'pmv-common';
import { SituacaoEditalFilter } from '../models/situacao-edital-filter.model';
import { ItemEdital } from '../models/edital-item-model';
import { ArquivoEdital } from '../models/edital-arquivo-model';
import { Data } from '@angular/router';

@Injectable()
export class ItemEditalService {

  constructor(private httpClient: HttpClient) { }

  GetByParam(id: number): Observable<Edital[]> {
    return this.httpClient.get<Edital[]>(`/Edital/GetByParam/${id}`);
  }
  
  GetByParamItem(tipo: number, itemconc: number, cdhierarq: number, tpConc: number): Observable<ItemEdital> {
    return this.httpClient.get<ItemEdital>(`/Edital/GetByParamItem/${tipo}/${itemconc}/${cdhierarq}/${tpConc}`);
  }
  
  GetByParamTipoTituloCombobox(tipo: number, itemconc: number, cdhierarq: number): Observable<Combobox[]> {
    return this.httpClient.get<Combobox[]>(`/Edital/GetByParamTipoTitulo/Combobox/${tipo}/${itemconc}/${cdhierarq}`);
  }

  GetByParamArquivoItem(tipo: number, itemconc: number, cdhierarq: number, tpConc: number): Observable<ArquivoEdital[]> {
    return this.httpClient.get<ArquivoEdital[]>(`/Edital/GetByParamArquivoItem/${tipo}/${itemconc}/${cdhierarq}/${tpConc}`);
  }

  getAll(page?: number, itemsPerPage?: number, filter?: SituacaoEditalFilter): Observable<ResultGetPaged<SituacaoEditalFilter>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<SituacaoEditalFilter>>('/Edital/GetByFilters', filter);
  }

  GetByParamItemCombobox(id: number, tpConc: number): Observable<Combobox[]> {
    return this.httpClient.get<Combobox[]>(`/Edital/GetByParamItem/Combobox/${id}/${tpConc}`);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/item-edital.service.ts